import PropTypes from 'prop-types'
import React, { Component } from 'react'

import StickySquare from 'components/StickySquare'
import { RU, IE, US } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { MenuMainConsumer } from 'contexts/MenuMain'
import { ResizeContext } from 'contexts/Resize'
import { LocalizationConsumer } from 'contexts/Localization'
import { LastBlock } from 'styles/components/layout'
import { OrderTestWidget } from 'widgets/OrderTestWidget'
import {
  black,
  white,
  grass,
  lilac,
  materialRed,
  orange,
  pictonBlue,
} from 'styles/theme/colors'

import BHowAnalyse from './components/BHowAnalyse'
import BHowCollect from './components/BHowCollect'
import BHowFirst from './components/BHowFirst'
import BHowInterpreting from './components/BHowInterpreting'
import BHowOrder from './components/BHowOrder'
import BHowProtection from './components/BHowProtection'
import BHowRegister from './components/BHowRegister'
import BHowResults from './components/BHowResults'
import BHowRetest from './components/BHowRetest/BHowRetest'
import BHowReturn from './components/BHowReturn'

const STICKY_SQUARE_TEXT_COLORS = [
  black,
  black,
  black,
  white,
  black,
  white,
  black,
  white,
]

class BiomeHowItWorks extends Component {
  constructor(props) {
    super(props)

    this.stickySquareBgColors = [
      grass,
      white,
      lilac,
      props.locale === RU || props.locale === IE ? materialRed : orange,
      grass,
      pictonBlue,
      orange,
      grass,
    ]

    this.blocks = this.stickySquareBgColors.map(() => React.createRef())
    this.state = {
      stickySquareActive: false,
    }
  }

  activateSticky = () => this.setState({ stickySquareActive: true })

  deactivateSticky = () => this.setState({ stickySquareActive: false })

  render() {
    const { texts, pathCdn, locale } = this.props
    const { stickySquareActive } = this.state
    const viewport = this.context
    const isMobile = !!(viewport.mobile && viewport.breakpoint !== '')
    const isUs = locale === US

    return (
      <>
        <BHowFirst data={texts.first} secondBlockRef={this.blocks[0]} />

        <div ref={this.blocks[0]}>
          <BHowOrder
            {...{ pathCdn }}
            index={1}
            data={texts.order_biome}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[1]}>
          <BHowRegister
            index={2}
            data={texts.kit_register}
            isSquareHidden={stickySquareActive}
            pathCdn={pathCdn}
          />
        </div>

        <div ref={this.blocks[2]}>
          <BHowCollect
            index={3}
            data={texts.collect}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[3]}>
          <BHowReturn
            index={4}
            data={texts.return_kit}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[4]}>
          <BHowAnalyse
            index={5}
            data={texts.analyse}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[5]}>
          <BHowInterpreting
            index={6}
            data={texts.interpreting}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <div ref={this.blocks[6]}>
          <BHowResults
            index={7}
            data={texts.results}
            pathCdn={pathCdn}
            locale={locale}
            isSquareHidden={stickySquareActive}
          />
        </div>
        <div ref={this.blocks[7]}>
          <BHowRetest
            index={8}
            data={texts.retest}
            cdnPath={pathCdn}
            locale={locale}
            isSquareHidden={stickySquareActive}
          />
        </div>

        <BHowProtection data={texts.protection} />

        {isUs ? (
          <LocalizationConsumer>
            {({ dict }) => (
              <OrderTestWidget
                className='py-md-6'
                productType={GOODS_TYPES.biome}
                commonTexts={dict}
              />
            )}
          </LocalizationConsumer>
        ) : (
          <LastBlock>
            <CartSaleWideContainer
              className='pt-2 pt-md-6 mt-md-6'
              productType={GOODS_TYPES.biome}
            />

            <DistributionBannerContainer />
          </LastBlock>
        )}

        {isMobile ? null : (
          <MenuMainConsumer>
            {({ menuNode }) => (
              <StickySquare
                topOffsetNode={menuNode}
                isActive={stickySquareActive}
                blocks={this.blocks}
                squareColors={this.stickySquareBgColors}
                textColors={STICKY_SQUARE_TEXT_COLORS}
                activateStickyHandler={this.activateSticky}
                deactivateStickyHandler={this.deactivateSticky}
              />
            )}
          </MenuMainConsumer>
        )}
      </>
    )
  }
}

BiomeHowItWorks.contextType = ResizeContext

BiomeHowItWorks.propTypes = {
  pathCdn: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  locale: PropTypes.string,
}

export default BiomeHowItWorks
